// *
// * CONSTANTS
// *

export const TRAILER_AUTOPLAY_DELAY_MS = 2500
export const MIN_TRAILER_DURATION_SEC = 3

/** Minimum autoScroll duration in seconds to allow trailer playback on banners */
export const MIN_BANNER_AUTO_SCROLL_DURATION_MS = 2000
/** Delay in ms before switching to next slide after trailer ends */
export const NEXT_SLIDE_DELAY_MS = 1000

export const TrailerContentType = {
  VOD: 'vod',
  TVSHOW: 'tvshow',
} as const
export type TrailerContentType =
  (typeof TrailerContentType)[keyof typeof TrailerContentType]

export interface TrailerFlowParams {
  contentType: TrailerContentType
  contentId: number
  /** Whether the content has a trailer (trailerPresent field) */
  hasTrailer: boolean
  locked: boolean
  free?: boolean
  autoScrollEnabled?: boolean
  /* analytix related fields */
  routeName?: string
  categoryName?: string
  contentName?: string
}

/** Params received when banner becomes visible in carousel */
export interface BannerVisibleParams {
  contentId: number
  contentType: TrailerContentType
  trailerPresent: boolean
  resourceType: string
  autoScrollIn: number
  bannerIndex?: number
  locked: boolean
  blockedByAcl?: boolean
  free?: boolean
  autoScrollEnabled?: boolean
  contentName?: string
}
